<div class="confirmation-dialog-container">
  <wcg-dialog [title]="data.title" [size]="data.dialogSize">
    <div secondary>
      <button
        color="primary"
        mat-button
        class="mdc-cancel-button"
        (click)="cancel()"
      >
        Cancel
      </button>
    </div>
    <div primary>
      <button
        wcg-button
        mat-flat-button
        color="primary"
        [disabled]="!isValid()"
        (click)="manageContactInfo(data.btnEvent)"
      >
        {{ data.buttonTitle }}
      </button>
    </div>
    <div content>
      @if (data.inputType !== "mailing-address-json") {
        <div class="mt-20">
          @if (data.inputType !== "dropdown") {
            <mat-form-field>
              <mat-label>{{ data.inputLable }}</mat-label>
              <input matInput [formControl]="inputValue" />
              @if (inputValue.value) {
                <button
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="clearInput()"
                >
                  <mat-icon>cancel</mat-icon>
                </button>
              }
            </mat-form-field>
          }
          @if (data.inputType === "dropdown") {
            <mat-form-field>
              <mat-label>{{ data.inputLable }}</mat-label>
              <mat-select [formControl]="inputValue" (click)="searchTerm = ''">
                <input
                  [(ngModel)]="searchTerm"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="Search.."
                  class="profile-search"
                />
                @for (
                  option of data.dropDownList | searchFilter: searchTerm;
                  track option.id
                ) {
                  <mat-option [value]="option.id">{{ option.name }}</mat-option>
                }
              </mat-select>
              @if (inputValue.value) {
                <button
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="clearInput()"
                >
                  <mat-icon>cancel</mat-icon>
                </button>
              }
            </mat-form-field>
          }
        </div>
      }

      @if (data.inputType === "mailing-address-json") {
        <div class="mt-20">
          <form [formGroup]="mailingAddressForm">
            <mat-form-field>
              <mat-label>Name</mat-label>
              <input matInput formControlName="name" />
              @if (mailingAddressForm.controls["name"].value) {
                <button
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="clearInput('name')"
                >
                  <mat-icon>cancel</mat-icon>
                </button>
              }
              @if (
                mailingAddressForm.controls.name.hasError("required") &&
                (mailingAddressForm.controls.name.dirty ||
                  mailingAddressForm.controls.name.touched)
              ) {
                <mat-error> Name is required. </mat-error>
              }
            </mat-form-field>
            <mat-form-field>
              <mat-label>Address Line1</mat-label>
              <input matInput formControlName="address1" />
              @if (mailingAddressForm.controls["address1"].value) {
                <button
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="clearInput('address1')"
                >
                  <mat-icon>cancel</mat-icon>
                </button>
              }
              @if (
                mailingAddressForm.controls.address1.hasError("required") &&
                (mailingAddressForm.controls.address1.dirty ||
                  mailingAddressForm.controls.address1.touched)
              ) {
                <mat-error> Address Line1 is required. </mat-error>
              }
              @if (
                mailingAddressForm.controls.address1.hasError("maxlength") &&
                !mailingAddressForm.controls.address1.hasError("required") &&
                (mailingAddressForm.controls.address1.dirty ||
                  mailingAddressForm.controls.address1.touched)
              ) {
                <mat-error>
                  Maximum Address Line1 length is
                  {{
                    mailingAddressForm.controls.address1.errors?.maxlength
                      .requiredLength
                  }}
                  characters.
                </mat-error>
              }
            </mat-form-field>
            <mat-form-field>
              <mat-label>Address Line2</mat-label>
              <input matInput formControlName="address2" />
              @if (mailingAddressForm.controls["address2"].value) {
                <button
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="clearInput('address2')"
                >
                  <mat-icon>cancel</mat-icon>
                </button>
              }
            </mat-form-field>
            <mat-form-field>
              <mat-label>Address Line3</mat-label>
              <input matInput formControlName="address3" />
              @if (mailingAddressForm.controls["address3"].value) {
                <button
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="clearInput('address3')"
                >
                  <mat-icon>cancel</mat-icon>
                </button>
              }
            </mat-form-field>
            <mat-form-field>
              <mat-label>City</mat-label>
              <input matInput formControlName="city" />
              @if (mailingAddressForm.controls["city"].value) {
                <button
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="clearInput('city')"
                >
                  <mat-icon>cancel</mat-icon>
                </button>
              }
              @if (
                mailingAddressForm.controls.city.hasError("maxlength") &&
                !mailingAddressForm.controls.city.hasError("required") &&
                (mailingAddressForm.controls.city.dirty ||
                  mailingAddressForm.controls.city.touched)
              ) {
                <mat-error>
                  Maximum City length is
                  {{
                    mailingAddressForm.controls.city.errors?.maxlength
                      .requiredLength
                  }}
                  characters.
                </mat-error>
              }
              @if (
                mailingAddressForm.controls.city.hasError("required") &&
                (mailingAddressForm.controls.city.dirty ||
                  mailingAddressForm.controls.city.touched)
              ) {
                <mat-error> City is required. </mat-error>
              }
            </mat-form-field>
            <div class="row">
              <div class="col-1-of-2">
                <mat-form-field>
                  <mat-label> Country</mat-label>
                  <mat-select
                    formControlName="country_id"
                    (selectionChange)="countryChanged($event.value)"
                  >
                    @for (country of countries; track country.id) {
                      <mat-option [value]="country.id">{{
                        country.name
                      }}</mat-option>
                    }
                  </mat-select>
                  @if (mailingAddressForm.controls["country_id"].value) {
                    <button
                      matSuffix
                      mat-icon-button
                      aria-label="Clear"
                      (click)="clearInput('country')"
                    >
                      <mat-icon>cancel</mat-icon>
                    </button>
                  }
                  @if (
                    mailingAddressForm.controls.country_id.hasError(
                      "required"
                    ) &&
                    (mailingAddressForm.controls.country_id.dirty ||
                      mailingAddressForm.controls.country_id.touched)
                  ) {
                    <mat-error> Country is required. </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-1-of-2">
                <mat-form-field>
                  <mat-label> {{ stateLabel }}</mat-label>
                  @if (stateLabel !== "State/Province") {
                    <mat-select formControlName="state">
                      @for (state of states; track state.id) {
                        <mat-option [value]="state.id">{{
                          state.name
                        }}</mat-option>
                      }
                    </mat-select>
                  }
                  @if (stateLabel === "State/Province") {
                    <input matInput formControlName="state" />
                  }
                  @if (mailingAddressForm.controls["state"].value) {
                    <button
                      matSuffix
                      mat-icon-button
                      aria-label="Clear"
                      (click)="clearInput('state')"
                    >
                      <mat-icon>cancel</mat-icon>
                    </button>
                  }
                  @if (
                    mailingAddressForm.controls.state.hasError("required") &&
                    (mailingAddressForm.controls.state.dirty ||
                      mailingAddressForm.controls.state.touched)
                  ) {
                    <mat-error> {{ stateLabel }} is required. </mat-error>
                  }
                  @if (
                    mailingAddressForm.controls.state.hasError("maxlength")
                  ) {
                    <mat-error>
                      Maximum {{ stateLabel }} length is
                      {{
                        mailingAddressForm.controls.state.errors?.maxlength
                          .requiredLength
                      }}
                      characters.
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
            <mat-form-field>
              <mat-label>Zip Code</mat-label>
              <input matInput formControlName="zip_code" />
              @if (mailingAddressForm.controls["zip_code"].value) {
                <button
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="clearInput('zip_code')"
                >
                  <mat-icon>cancel</mat-icon>
                </button>
              }
              @if (
                mailingAddressForm.controls.zip_code.hasError("required") &&
                (mailingAddressForm.controls.zip_code.dirty ||
                  mailingAddressForm.controls.zip_code.touched)
              ) {
                <mat-error> Zip Code is required. </mat-error>
              }
              @if (
                mailingAddressForm.controls.zip_code.hasError(
                  "invalidCanZipCode"
                ) &&
                !mailingAddressForm.controls.zip_code.hasError("required") &&
                !mailingAddressForm.controls.zip_code.hasError(
                  "invalidUsZipCode"
                )
              ) {
                <mat-error> Only letters and numbers are allowed. </mat-error>
              }
              @if (
                mailingAddressForm.controls.zip_code.hasError(
                  "invalidUsZipCode"
                ) &&
                !mailingAddressForm.controls.zip_code.hasError("required") &&
                !mailingAddressForm.controls.zip_code.hasError(
                  "invalidCanZipCode"
                )
              ) {
                <mat-error>
                  Only numbers of the format : ##### or #####-#### are allowed.
                </mat-error>
              }
              @if (
                mailingAddressForm.controls.zip_code.hasError("maxlength") &&
                !mailingAddressForm.controls.zip_code.hasError("required")
              ) {
                <mat-error>
                  Maximum Zip Code length is
                  {{
                    mailingAddressForm.controls.zip_code.errors?.maxlength
                      .requiredLength
                  }}
                  characters.
                </mat-error>
              }
            </mat-form-field>
          </form>
        </div>
      }

      @if (data.isDefaultVisible) {
        <mat-checkbox [checked]="isDefault" [(ngModel)]="isDefault">
          Set as deafult
        </mat-checkbox>
      }
    </div>
  </wcg-dialog>
</div>
